import { EditContainer } from 'features/globalSetup/forms/Prebid/Modules/UserIdsForm/GeneralForm'

export const GeneralPage = (): JSX.Element => {
  return <EditContainer />
}
